module.exports = __webpack_public_path__ + "static/media/goback-white.e7944957.svg";